import { render } from "./OperationAreaBlock.vue?vue&type=template&id=6b9e42ea"
import script from "./OperationAreaBlock.vue?vue&type=script&lang=js"
export * from "./OperationAreaBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/OperationAreaBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b9e42ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b9e42ea', __exports__)) {
    api.reload('6b9e42ea', __exports__)
  }
  
  module.hot.accept("./OperationAreaBlock.vue?vue&type=template&id=6b9e42ea", () => {
    api.rerender('6b9e42ea', render)
  })

}


export default __exports__